module.exports = __webpack_public_path__ + "static/YangAnimsForMountain_IDLE-009d536b2b054b69c5fc675e9040c68d.gif";